export const itemProperties = ['SerialNumber', 'InventoryID'];
